import AppLogoIcon from "./app-logo-icon"

export default function AppLogo() {
  return (
    <div className="flex items-center gap-2">
      <AppLogoIcon className="size-6 fill-current text-white" />
      <span className="text-sm font-semibold">Spinus</span>
    </div>
  )
}
